import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { StoreProvider } from './store/useStore';
import { Navbar } from './components/layout/Navbar';
import { Footer } from './components/layout/Footer';
import { AIRecoveryChatModal } from './components/ai/AIRecoveryChatModal';

// Pages
import { Home } from './pages/Home';
import { CheckIdentity } from './pages/CheckIdentity';
import { SecurityScorePage } from './pages/SecurityScore';
import { Dashboard } from './pages/Dashboard';
import { AlertsPage } from './pages/Alerts';
import { ScamCheckerPage } from './pages/ScamChecker';
import { WebsiteCheckerPage } from './pages/WebsiteChecker';
import { IdentityTheftPage } from './pages/IdentityTheft';
import { RecoveryWizardPage } from './pages/RecoveryWizard';
import { IdentityDocumentsPage } from './pages/IdentityDocuments';
import { IdWatermarkPage } from './pages/IdWatermark';
import { AccountSecurityPage } from './pages/AccountSecurity';
import { FamilyProtectionPage } from './pages/FamilyProtection';
import { PricingPage } from './pages/Pricing';
import { ResourcesPage } from './pages/Resources';
import { ResourceDetailPage } from './pages/ResourceDetail';
import { PrivacyPage } from './pages/Privacy';
import { HowItWorksPage } from './pages/HowItWorks';
import { LoginPage } from './pages/Login';
import { RegisterPage } from './pages/Register';
import { ForgotPasswordPage } from './pages/ForgotPassword';
import { SettingsPage } from './pages/Settings';
import { AdminDashboardPage } from './pages/AdminDashboard';

// Scroll to top on navigation
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

export const App: React.FC = () => {
  return (
    <StoreProvider>
      <Router>
        <ScrollToTop />
        <div className="min-h-screen bg-slate-950 text-slate-100 flex flex-col font-sans selection:bg-emerald-500 selection:text-white">
          <Navbar />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/check-identity" element={<CheckIdentity />} />
              <Route path="/security-score" element={<SecurityScorePage />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/alerts" element={<AlertsPage />} />
              <Route path="/scam-checker" element={<ScamCheckerPage />} />
              <Route path="/website-checker" element={<WebsiteCheckerPage />} />
              <Route path="/identity-theft" element={<IdentityTheftPage />} />
              <Route path="/recovery-wizard" element={<RecoveryWizardPage />} />
              <Route path="/identity-documents" element={<IdentityDocumentsPage />} />
              <Route path="/id-watermark" element={<IdWatermarkPage />} />
              <Route path="/account-security" element={<AccountSecurityPage />} />
              <Route path="/family" element={<FamilyProtectionPage />} />
              <Route path="/pricing" element={<PricingPage />} />
              <Route path="/resources" element={<ResourcesPage />} />
              <Route path="/resources/:slug" element={<ResourceDetailPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/how-it-works" element={<HowItWorksPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/settings" element={<SettingsPage />} />
              <Route path="/admin" element={<AdminDashboardPage />} />
              {/* Fallback */}
              <Route path="*" element={<Home />} />
            </Routes>
          </main>
          <Footer />
          <AIRecoveryChatModal />
        </div>
      </Router>
    </StoreProvider>
  );
};
